// Weergavenaam van een gebruiker. De username (meestal een e-mailadres of een
// verkorte inlognaam) wordt nergens meer getoond; overal staat de naam.
//
// Terugval is nodig: de meeste accounts hebben voor-/achternaam nog niet
// ingevuld. Dan maken we er een leesbare naam van op basis van de inlognaam,
// zodat er nooit een leeg veld of een kaal e-mailadres in beeld komt. Zodra
// voor-/achternaam in Gebruikersbeheer ingevuld worden, wint die.

// "alieke.teslaa@stedin.net" -> "Alieke Teslaa", "F.Kojic" -> "F Kojic"
export function naamUitUsername(username) {
  if (!username) return 'Onbekend';
  const lokaal = String(username).split('@')[0];
  const delen = lokaal.split(/[._-]+/).filter(Boolean);
  if (!delen.length) return String(username);
  return delen.map(d => d.charAt(0).toUpperCase() + d.slice(1)).join(' ');
}

// Accepteert een gebruikersobject ({voornaam, achternaam, username}) of alleen
// een username-string, zodat het ook werkt bij audit- en feedbackregels waar
// enkel de inlognaam is opgeslagen.
export function weergavenaam(gebruiker, username) {
  if (typeof gebruiker === 'string' || gebruiker == null) {
    return naamUitUsername(gebruiker ?? username);
  }
  const naam = [gebruiker.voornaam, gebruiker.achternaam]
    .filter(d => d && String(d).trim())
    .join(' ')
    .trim();
  return naam || naamUitUsername(gebruiker.username ?? username);
}
